import './FreeText.scss';
import { safeHtml } from '../../../../services/helpers';

export default function FreeText({ content }) {

    return (
        <div className="workshop-free_text" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
    )
}